// extracted by mini-css-extract-plugin
module.exports =  {"textarea":"e462cbfa4b--textarea--K7RuB","counter":"e462cbfa4b--counter--roeZQ"};